<template>
  <v-container fluid v-if="model">
      <v-row>
          <v-col cols=12>
              <v-card>
                <v-toolbar flat color="secondary" dark>
                    <v-icon left>mdi-clipboard-text</v-icon>
                    <v-toolbar-title>Purchase order - Detail</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-dialog v-if="!this.model.currency" v-model="setCurrency" max-width=350px>
                      <template v-slot:activator={on}>
                        <v-btn
                          color=orange
                          v-on=on
                        >
                          <v-icon left>mdi-currency-usd</v-icon>Set Currency
                        </v-btn>
                      </template>
                      <v-card>
                        <v-toolbar flat color="secondary" dark>Set currency</v-toolbar>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols=12>
                                <p>When you set a currency for a PurchaseOrder all product in this PurchaseOrder will be set in this currency.</p>
                                <v-form>
                                  <v-select v-model="currency" :items="currencies" item-text="currency" item-value="currency"></v-select>
                                </v-form>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text @click="setCurrency=false">
                            cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn primary @click="saveCurrency">Submit</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    
                </v-toolbar>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">poNumber</div>
                      {{ model.poNumber }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">arrivalDueDate</div>
                      {{ model.arrivalDueDate }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">orderCancelDate</div>
                      {{ model.orderCancelDate }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">orderDate</div>
                      {{ model.orderDate }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">paymentStatus</div>
                      {{ model.paymentStatus }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">privateNotes</div>
                      {{ model.privateNotes }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">publicNotes</div>
                      {{ model.publicNotes }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">requestedShipDate</div>
                      {{ model.requestedShipDate }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">sentStatus</div>
                      {{ model.sentStatus }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">shipToAddress</div>
                      {{ model.shipToAddress }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">shipToWarehouse</div>
                      {{ model.shipToWarehouse }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">shippingCarrier</div>
                      {{ model.shippingCarrier }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">shippingClass</div>
                      {{ model.shippingClass }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">supplier</div>
                      {{ model.supplier.name }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">trackingInfo</div>
                      {{ model.trackingInfo }}
                    </v-flex>
                    <v-flex xs12 md3 mb-3>
                      <div class="text-capitalize overline text--secondary">currency</div>
                      {{ model.currency }}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols=12>
              <v-card>
                <v-toolbar flat color="secondary" dark>
                    <v-icon left>mdi-format-list-bulleted</v-icon>
                    <v-toolbar-title>PO's Rows</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :items="model.lines" :headers="headers">
                    </v-data-table>
                </v-card-text>
              </v-card>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex"
export default {

  data: function() {
    return {
      setCurrency:null,
      currency:null,
      poId: null,
      model: null,
      headers:[
          {text:'Sku', value:'sku'},
          {text:'Unit Cost', value:'cost'},
          {text:'quantity', value:'quantity'},
          {text:'Total', value:'total'},
      ]
    };
  },
  computed:{
    ...mapGetters("currencies",["currencies"])
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.poId = this.$route.params.id;
      this.getPO(this.poId);
    } else {
      this.$route.push("/purchase-order");
    }
  },
  methods: {
    getPO(id) {
      this.$store
        .dispatch("purchaseOrders/get", {
          id: id
        })
        .then(data => (this.model = data.po));
    },
    saveCurrency(){
      this.$store
        .dispatch("purchaseOrders/setCurrency",{poId:this.poId,currency:this.currency})
        .then(() => {
          this.setCurrency=false;
          this.getPO(this.poId)
        })
    }
  }
}
</script>

<style>

</style>